import { safeJson } from "src/app/helpers/Index";
import "./AdminParkingEditor.css";
import React from "react";
import Konva from "konva";
import { Label, Stage, Rect, Text, Layer, Group, Transformer, Circle } from "react-konva";
import { ParkingSpaceService } from "src/app/services/ParkingSpaceService";
import { ParkingSpace } from "src/app/interfaces/ParkingSpace";
import { SpaceType } from "src/app/enums/SpaceType";


type Props = {}
type State = {
	isLoading: boolean;
	parkingSpaces: ParkingSpace[]
};

export class AdminParkingEditor extends React.Component<Props, State> {
	dt: any;
	toast: any;
	itemName: string = "Partner";
	itemNamePlural: string = "Partners";

	private layer: React.RefObject<Konva.Layer> = React.createRef();
	private stage: React.RefObject<Konva.Stage> = React.createRef();

	constructor(props: Props) {
		super(props);
		this.state = { isLoading: false, parkingSpaces: [] };
		this.getItems();
	}

	componentDidMount() {
		this.getItems();
	}

	getColour(item: ParkingSpace)
	{
		switch(item.spaceType){
			case SpaceType.Player:
				return "#1B728D"
				break;
			case SpaceType.General:
				return  "#FFCA40";
				break;
		}
	}

	getTextColour(item: ParkingSpace)
	{
		switch(item.spaceType){
			case SpaceType.Player:
				return "#FFF"
				break;
			case SpaceType.General:
				return  "#000";
				break;
		}
	}

	async getItems() {
		this.setState({ isLoading: true });
		const res = await safeJson(ParkingSpaceService.getAll());
		if (res && res.error) {
			this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
			this.setState({ isLoading: false });
		}
		this.setState({ isLoading: false, parkingSpaces: res });
	}

	handleDragStart = (e: any) => {
		const id = e.target.attrs.name;
		const parkingSpaces = this.state.parkingSpaces;
		const parkingSpace = parkingSpaces.find((i) => i.designation === id)!;
		const index = parkingSpaces.indexOf(parkingSpace);
		this.setState({
			parkingSpaces,
		});
	};
	handleDragEnd = async (e: any) => {
		const id = e.target.attrs.name;
		const parkingSpaces = this.state.parkingSpaces;
		const parkingSpace = parkingSpaces.find((i) => i.designation === id)!;
		const index = this.state.parkingSpaces.indexOf(parkingSpace);
		// update item position
		parkingSpaces[index] = {
			...parkingSpace,
			xPosition: e.target.x(),
			yPosition: e.target.y(),
		};
		this.setState({ parkingSpaces });
		await this.saveItem(id);
	};

	render() {
		return (
			<Stage ref={this.stage} width={window.innerWidth - 400} height={window.innerHeight - 150} style={{ backgroundColor: "#FFF" }}>
				<Layer ref={this.layer}>
					<Text text="Try to drag a star" />
					{this.state.parkingSpaces.map((item) => (
						<Group
							name={item.designation}
							draggable
							onDragStart={this.handleDragStart}
							onDragEnd={this.handleDragEnd}
							x={item.xPosition}
							y={item.yPosition}
							width={75}
							height={40}
							rotation={item.rotation}>
							<Rect				
							width={75}
							height={40}
							fill={this.getColour(item)}/>
							<Text text={item.designation}
							x={10}
							y={10} 							
							fontSize={20}
							fill={this.getTextColour(item)}						
							></Text>
						</Group>
					))}
				</Layer>
			</Stage>
		);
	}

	async saveItem(name:string) {
		console.log("Hit")
		this.setState({isLoading: true});
			const toUpdate = this.state.parkingSpaces.find((i) => i.designation === name)!;
			const res = await safeJson(ParkingSpaceService.updateSingleById(toUpdate.id,toUpdate));
			if (res && res.error) {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
			this.setState({isLoading: false});
			this.toast.show({closable: false, detail: "Space has been saved", life: 5000, severity: "success", summary: this.itemName + " saved!"});
		this.getItems();
	}



}